var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gold-title",class:_vm.extraClass,style:(`${_vm.width ? `width:${_vm.width}px` : ''} ${_vm.size ? `font-size: ${_vm.size}px` : ''}`)},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.context}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }